module.exports = __webpack_public_path__ + "static/img/2_9@2x.2ceeebd.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/home/2_9@2x.png
// module id = hXXe
// module chunks = 8